import React, { useEffect } from "react";
// import "./gosuslugi-banner.css"; // сюда вынесем css

export default function GosuslugiBanner() {
  useEffect(() => {
    // === Подключаем внешний скрипт ===
    const script = document.createElement("script");
    script.src = "https://pos.gosuslugi.ru/bin/script.min.js";
    script.async = true;
    document.body.appendChild(script);

    // === Функция для адаптивности баннера ===
    const POS_PREFIX_12 = "--pos-banner-fluid-12__";
    const posOptionsInitialBanner12 = {
      background: "#50b3ff",
      "grid-template-columns": "100%",
      "grid-template-rows": "188px auto",
      "max-width": "100%",
      "text-font-size": "24px",
      "text-margin": "0 0 24px 0",
      "button-wrap-max-width": "100%",
      "bg-url":
        "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6.svg')",
      "bg-url-position": "center bottom",
      "bg-size": "contain",
      "content-padding": "24px",
      "content-grid-row": "0",
      "logo-width": "65px",
      "logo-wrap-top": "16px",
      "logo-wrap-right": "13px",
      "slogan-font-size": "12px",
    };

    const setStyles = (options, el) => {
      Object.keys(options).forEach((key) => {
        el.style.setProperty(POS_PREFIX_12 + key, options[key]);
      });
    };

    const removeStyles = (options, el) => {
      Object.keys(options).forEach((key) => {
        el.style.removeProperty(POS_PREFIX_12 + key);
      });
    };

    const changePosBannerOnResize = () => {
      const el = document.documentElement;
      const opts = { ...posOptionsInitialBanner12 };
      const wrapper = document.getElementById("js-show-iframe-wrapper");
      const width = wrapper ? wrapper.offsetWidth : document.body.offsetWidth;

      if (width > 340) {
        opts["grid-template-rows"] = "236px auto";
        opts["bg-url"] =
          "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6-2.svg')";
        opts["button-wrap-max-width"] = "209px";
        opts["content-padding"] = "24px 32px";
        opts["text-margin"] = "0 0 24px 0";
      }
      if (width > 350)
        opts["bg-url-position"] = "center bottom calc(100% - 40px)";
      if (width > 415) opts["bg-url-position"] = "center bottom";
      if (width > 568) {
        opts["grid-template-columns"] = "1fr 292px";
        opts["grid-template-rows"] = "100%";
        opts["content-grid-row"] = "1";
        opts["content-padding"] = "32px 24px 24px";
        opts["bg-url"] =
          "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6.svg')";
      }
      if (width > 783) {
        opts["grid-template-columns"] = "1fr 400px";
        opts["text-font-size"] = "32px";
        opts["content-padding"] = "32px 24px";
        opts["bg-url"] =
          "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6-2.svg')";
        opts["bg-url-position"] = "center bottom calc(100% - 25px)";
      }
      if (width > 820) {
        opts["grid-template-columns"] = "1fr 420px";
        opts["bg-url-position"] = "center bottom";
      }
      if (width > 1098) {
        opts["bg-url"] =
          "url('https://pos.gosuslugi.ru/bin/banner-fluid/6/banner-fluid-bg-6-3.svg')";
        opts["grid-template-columns"] = "1fr 557px";
        opts["text-font-size"] = "36px";
        opts["content-padding"] = "32px 32px 32px 50px";
        opts["logo-width"] = "78px";
        opts["logo-wrap-top"] = "20px";
        opts["logo-wrap-right"] = "17px";
        opts["slogan-font-size"] = "15px";
      }
      if (width > 1422) {
        opts["max-width"] = "1422px";
        opts["grid-template-columns"] = "1fr 720px";
        opts["content-padding"] = "32px 48px 32px 160px";
        opts.background = "linear-gradient(90deg, #50b3ff 50%, #f8efec 50%)";
      }
      setStyles(opts, el);
    };

    changePosBannerOnResize();
    window.addEventListener("resize", changePosBannerOnResize);

    // Загружаем виджет
    script.onload = () => {
      if (window.Widget) {
        window.Widget("https://pos.gosuslugi.ru/form", 228767);
      }
    };

    return () => {
      window.removeEventListener("resize", changePosBannerOnResize);
      removeStyles(posOptionsInitialBanner12, document.documentElement);
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section>
      <div id="js-show-iframe-wrapper">
        <div className="pos-banner-fluid bf-12">
          <div className="bf-12__decor">
            <div className="bf-12__logo-wrap">
              <img
                className="bf-12__logo"
                src="https://pos.gosuslugi.ru/bin/banner-fluid/gosuslugi-logo-blue.svg"
                alt="Госуслуги"
              />
              <div className="bf-12__slogan">Решаем вместе</div>
            </div>
          </div>
          <div className="bf-12__content">
            <div className="bf-12__text">Не смогли записаться к врачу?</div>
            <div className="bf-12__bottom-wrap">
              <div className="bf-12__btn-wrap">
                <button className="pos-banner-btn_2" type="button">
                  Написать о проблеме
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
